export default "__VITE_ASSET__dcedec79__"